module.exports = "//public.zight.com/packs/media/images/onboarding/windows-b220ed87a042dab28df8d14d1e0673e2.svg";